<template>
  <div>
    <div v-for="(item, index) in pageRenderConfig" :key="index">
      <!-- 图片模块 -->
      <van-swipe v-if="item.type === 'image'" class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(imgItem, vindex) in item.data.field_value" :key="vindex">
          <img class="img" :src="imgItem.url" alt="">
        </van-swipe-item>
      </van-swipe>

      <!-- 表单模块 -->
      <van-form v-if="item.type === 'form'" @submit="onSubmit" @failed="onFailed">
        <div v-for="(field, findex) in item.data" :key="findex">
          <!-- 城市下拉 -->
          <div v-if="field.field_key === 'city' && field.field_type === 'select'">
            <van-field
              v-model="formData.prov_city_name"
              is-link
              readonly
              :name="field.field_key"
              :label="field.field_title"
              :placeholder="field.field_desc"
              :required="field.field_required === 1"
              :rules="[{ pattern: patterns.prov_city_name, message: '' }]"
              @click="cityShow = true"
            />
            <van-popup v-model="cityShow" round position="bottom" :style="{ height: '80%' }" @close="closeCityPopup">
              <van-search
                v-model="citySearchValue"
                placeholder="请输入城市关键词"
                show-action
                input-align="center"
                @search="citySearch"
              >
                <template #action>
                  <div @click="citySearch">搜索</div>
                </template>
              </van-search>
              <van-cascader
                v-model="formData[field.field_key]"
                title="请选择城市"
                :options="cityList"
                :field-names="{ text: 'name', value: 'id' }"
                @close="cityShow = false"
                @change="cityChange"
                @finish="cityFinish"
              />
            </van-popup>
          </div>

          <!-- 车系下拉 -->
          <div v-if="field.field_key === 'series' && field.field_type === 'select'">
            <van-field
              v-model="formData.brand_series_name"
              is-link
              readonly
              :name="field.field_key"
              :label="field.field_title"
              :placeholder="field.field_desc"
              :required="field.field_required === 1"
              :rules="[{ required: field.field_required === 1, message: '' }]"
              @click="openSeriesPopup"
            />
            <van-popup v-model="seriesShow" round position="bottom" :style="{ height: '80%' }" @close="closeSeriesPopup">
              <van-search
                v-model="seriesSearchValue"
                placeholder="请输入品牌或车系关键词"
                show-action
                input-align="center"
                @search="seriesSearch"
              >
                <template #action>
                  <div @click="seriesSearch">搜索</div>
                </template>
              </van-search>
              <van-cascader
                :key="seriesCascaderKey"
                v-model="seriesCascaderValue"
                title="请选择车系"
                :options="seriesList"
                :field-names="{ text: 'name', value: 'id' }"
                @close="seriesShow = false"
                @finish="seriesFinish"
              />
            </van-popup>
          </div>

          <!-- 单选 -->
          <div v-else-if="field.field_type === 'radio'">
            <van-field
              :name="field.field_key"
              :label="field.field_title"
              :required="field.field_required === 1"
              :rules="[{ required: field.field_required === 1, message: '请至少选择一个' }]"
            >
              <template #input>
                <van-radio-group v-model="formData[field.field_key]" direction="horizontal" class="radio-group">
                  <div v-for="(rItem, rIndex) in field.field_value" :key="rIndex" class="radio-item">
                    <van-radio :name="rItem.id">
                      {{ rItem.alias ?? rItem.name }}
                    </van-radio>
                  </div>
                </van-radio-group>
              </template>
            </van-field>
          </div>

          <!-- 手机和验证码 -->
          <div v-else-if="field.field_key === 'phone'">
            <van-field
              v-model="formData[field.field_key]"
              clearable
              maxlength="11"
              type="number"
              :name="field.field_key"
              :label="field.field_title"
              :placeholder="field.field_desc"
              :required="field.field_required === 1"
              :rules="[{ pattern: patterns.phone, message: '' }]"
            />
            <van-field
              v-if="field.field_value_check && field.field_value_check.includes('verification_code') && !isAfterSms"
              v-model="formData['sms_code']"
              center
              clearable
              name="sms_code"
              maxlength="6"
              type="number"
              label="验证码"
              placeholder="请输入验证码"
              :required="field.field_required === 1"
              :rules="[{ required: field.field_required === 1, message: '' }]"
            >
              <template #button>
                <van-button
                  native-type="button"
                  size="small"
                  type="info"
                  :disabled="smsButtonDisable"
                  @click="checkCaptcha"
                >{{ smsButtonValue }}</van-button>
              </template>
            </van-field>
          </div>

          <!-- 其他输入框 -->
          <van-field
            v-else-if="field.field_type === 'input'"
            v-model="formData[field.field_key]"
            clearable
            :name="field.field_key"
            :label="field.field_title"
            :placeholder="field.field_desc"
            :required="field.field_required === 1"
            :rules="[{ required: field.field_required === 1, message: '' }]"
            @blur="onBlur(field.field_key, field.field_value_check)"
          />

          <!-- 按钮 -->
          <div v-if="field.field_key === 'submit' && field.field_type === 'button'" style="display: flex; flex-direction: column; align-items: center; margin: 16px;">
            <div style="align-self: flex-start; margin-bottom: 10px;">
              <van-checkbox v-model="formData.ppis_agree" icon-size="12px" shape="square" style="margin-left: 10px;" @click="reportEvent('check_privacy', '')">
                <span style="font-size: 12px; color: #999;">阅读并同意<a href="javascript:void(0);" @click="openPPIS">《个人信息保护声明》</a></span>
              </van-checkbox>
            </div>
            <van-button round block type="info" style="margin-top: 8px;">
              {{ field.field_title }}
            </van-button>
            <div v-if="field.field_desc != ''" style="font-size: 11px; color: #999; margin-top: 5px; text-align: center;">
              {{ field.field_desc }}
            </div>
          </div>
        </div>
      </van-form>
    </div>

    <!-- 个人信息保护声明 -->
    <van-dialog
      v-model="ppisShow"
      :show-confirm-button="false"
      :close-on-click-overlay="true"
      @close="formData.ppis_agree = true"
    >
      <div class="dialog-container">
        <div class="dialog-header">
          <button class="close-button" @click="ppisShow = false">✖</button>
        </div>
        <div class="dialog-content">
          <PPIS :company="companyName" />
        </div>
        <div class="dialog-footer">
          <van-button type="primary" block @click="ppisShow = false">
            我 已 阅 读
          </van-button>
        </div>
      </div>
    </van-dialog>

    <!-- ICP备案 -->
    <div class="icp">
      <span>{{ companyName }}</span> | <span>{{ icpInfo }}</span>
    </div>

    <van-number-keyboard safe-area-inset-bottom />

    <!-- 后置验证码输入框 -->
    <div v-if="showAfterCaptcha" class="after-captcha-mask">
      <div class="after-captcha-dialog">
        <div class="after-captcha-title">短信验证码已发送</div>
        <div class="after-captcha-inputs">
          <van-field
            ref="afterCaptchaInput"
            v-model="formData.sms_code"
            class="after-captcha-input"
            input-align="center"
            type="number"
            maxlength="6"
            placeholder="请输入短信验证码"
            :disabled="afterCaptchaSending"
            @input="handleAfterCaptchaInput()"
          />
        </div>
        <div class="after-captcha-tips">
          <span v-if="afterCaptchaCount > 0">
            {{ afterCaptchaCount }}秒后可重新发送
          </span>
          <span v-else>
            <a href="javascript:;" :class="{ disabled: afterCaptchaSending }" @click="resendAfterCaptchaCode">
              重新发送验证码
            </a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Toast,
  Popup,
  Cascader,
  RadioGroup,
  Radio,
  Field,
  Form,
  Swipe,
  SwipeItem,
  CellGroup,
  Button,
  NumberKeyboard,
  Search,
  Checkbox,
  Dialog
} from 'vant'
import PPIS from './PPIS.vue'
import request from '../../utils/request'
export default {
  name: 'CarClue',
  components: {
    [Popup.name]: Popup,
    [Cascader.name]: Cascader,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Field.name]: Field,
    [Form.name]: Form,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [NumberKeyboard.name]: NumberKeyboard,
    [Search.name]: Search,
    [Checkbox.name]: Checkbox,
    [Dialog.Component.name]: Dialog.Component,
    PPIS
  },
  data() {
    return {
      queryObj: {},
      icpInfo: '',
      companyName: '',
      cityShow: false,
      citySearchValue: '',
      seriesShow: false,
      seriesSearchValue: '',
      seriesCascaderValue: '',
      seriesCascaderKey: 0,
      seriesRequestId: 0,
      patterns: {
        phone: /^1[3-9]\d{9}$/,
        prov_city_name: /^[\u4e00-\u9fa5]{2,}\/[\u4e00-\u9fa5]{2,}$/
      },
      cityList: [],
      seriesList: [],
      smsButtonValue: '发送验证码',
      smsButtonDisable: false,
      pageRenderConfig: [],
      ppisShow: false,
      formData: {
        prov_city_name: '',
        brand_series_name: '',
        sms_code: '',
        ppis_agree: false
      },
      isAfterSms: false,
      showAfterCaptcha: false,
      afterCaptchaTimer: null,
      afterCaptchaCount: 60,
      afterCaptchaSending: false
    }
  },
  watch: {
    showAfterCaptcha(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.afterCaptchaInput && this.$refs.afterCaptchaInput.focus()
        })
      }
    }
  },
  mounted() {
    this.init()
    this.reportEvent('enter_page', '')
    this.startReportTimer()
  },
  beforeDestroy() {
    if (this.afterCaptchaTimer) clearInterval(this.afterCaptchaTimer)
  },
  methods: {
    init() {
      // 把链接中的参数解析成对象保存
      this.queryObj = this.$route.query

      this.getPageRenderConfig()
      this.getCityList()
      this.getIcpInfo()
    },
    getPageRenderConfig() {
      let path = ''
      if (this.queryObj.is_demo) {
        path = `/car/${this.queryObj.uniq}/config?` + Object.entries(this.queryObj).map(([key, value]) => `${key}=${value}`).join('&')
      } else {
        path = `/car/${this.queryObj.uniq}/config`
      }
      request.get(path).then((res) => {
        if (!res.data) {
          return
        }
        this.pageRenderConfig = res.data

        // 初始化一些值
        this.pageRenderConfig.forEach((item) => {
          if (item.type === 'form' && item.data.length > 0) {
            item.data.forEach((field) => {
              // 默认值选中
              if (field.field_type === 'radio') {
                field.field_value.forEach((rItem) => {
                  if (rItem.selected && rItem.selected === 1) {
                    this.$set(this.formData, field.field_key, rItem.id)
                  }
                })
              } else if (field.field_key === 'phone') {
                // 后置验证码
                if (field.field_value_check && field.field_value_check.includes('verification_code_after')) {
                  this.isAfterSms = true
                }
              }
            })
          }
        })
      })
    },
    getCityList() {
      const data = {
        uniq: this.queryObj.uniq || '',
        name: this.citySearchValue
      }
      request.get('/car/cities', data).then((res) => {
        if (res.data && res.data.length > 0) {
          this.cityList = res.data
        }
      })
    },
    getSeriesList() {
      const keyword = (this.seriesSearchValue || '').trim()
      this.seriesRequestId += 1
      const requestId = this.seriesRequestId
      const data = {
        uniq: this.queryObj.uniq || '',
        name: keyword
      }
      request.get('/car/series', data).then((res) => {
        if (requestId !== this.seriesRequestId) {
          return
        }
        if (res.status === 'success') {
          this.seriesList = res.data || []
          this.seriesCascaderKey += 1
          return
        }
        Toast(res.msg || '车系加载失败')
      }).catch(() => {
        if (requestId !== this.seriesRequestId) {
          return
        }
        Toast('车系加载失败')
      })
    },
    getIcpInfo() {
      const path = `/car/${this.queryObj.uniq}/icp`
      const data = {
        link_id: this.queryObj.link_id,
        domain: window.location.origin
      }
      request.post(path, data).then((res) => {
        this.icpInfo = res.data.icp || ''
        this.companyName = res.data.company || ''
      })
    },
    citySearch() {
      this.getCityList()
    },
    cityChange(value) {
      const selected = value.selectedOptions[value.tabIndex]

      if (selected.children && selected.id === selected.code) {
        this.formData.prov_city_name = selected.name
      } else {
        const parts = this.formData.prov_city_name.split('/')
        if (parts.length > 1) {
          parts[parts.length - 1] = selected.name
          this.formData.prov_city_name = parts.join('/')
        } else {
          this.formData.prov_city_name += '/' + selected.name
        }
      }
    },
    closeCityPopup() {
      this.citySearchValue = ''
      this.getCityList()
    },
    cityFinish(value) {
      this.formData.city = value.value
      this.cityShow = false
    },
    openSeriesPopup() {
      this.seriesCascaderValue = this.formData.series || ''
      this.seriesShow = true
      this.getSeriesList()
    },
    seriesSearch() {
      this.getSeriesList()
    },
    closeSeriesPopup() {
      this.seriesSearchValue = ''
      this.seriesCascaderValue = this.formData.series || ''
      this.getSeriesList()
    },
    seriesFinish(value) {
      const options = value.selectedOptions || []
      const brand = options[0]
      const series = options[options.length - 1]
      if (!brand || !series || brand === series) {
        return
      }
      this.formData.brand_series_name = brand.name + '/' + series.name
      this.formData.series = series.id
      this.seriesCascaderValue = series.id
      this.seriesShow = false
    },
    checkFormData() {
      // 检查必填项
      if (!this.patterns.phone.test(this.formData.phone)) {
        Toast('请填写正确的手机号')
        return false
      }
      return true
    },
    async onSubmit() {
      if (!this.checkFormData()) {
        return
      }

      if (await this.checkRisk(this.formData.user_name)) {
        Toast('请填写有效的姓名')
        return
      }

      if (!this.formData.ppis_agree) {
        Toast('请阅读并同意《个人信息保护声明》')
        return
      }

      if (this.queryObj.is_demo) {
        Toast('预览模式不允许提交数据')
        return
      }

      // 检查手机号是否重复提交
      if (this.checkPhoneRepeat(this.formData.phone)) {
        Toast('您已经成功提交，不用重复提交')
        return
      }

      this.reportEvent('click_submit', '')

      // 后置验证方式
      if (this.isAfterSms && !this.showAfterCaptcha) {
        this.reportEvent('slide_succ', '')
        this.sendCaptcha({
          randstr: 'skip_captcha',
          ticket: 'skip_captcha',
          phone: this.formData.phone,
          page_url: window.location.href.split('?')[0] || ''
        })
        this.formData.sms_code = ''
        this.showAfterCaptcha = true
        this.afterCaptchaCount = 60
        this.startAfterCaptchaTimer()
        return
      }

      this.toSubmit()
    },
    toSubmit() {
      // 提交数据
      const submitData = {
        ...this.formData,
        ...this.queryObj
      }

      request.post('/car/clue/submit', submitData).then((res) => {
        if (res.status && res.status === 'success') {
          // 保存手机号,避免重复提交
          this.savePhone(submitData.phone)
          this.$router.push('/success')
        } else {
          Toast(res.msg || '提交失败')
        }
      }).catch((err) => {
        console.log('提交数据错误', err)
        Toast(err.response.data.msg || '提交失败')
      })
    },
    handleAfterCaptchaInput() {
      // 检查是否已输入6位
      if (this.formData.sms_code.length === 6) {
        this.showAfterCaptcha = false
        this.toSubmit()
      }
    },
    startAfterCaptchaTimer() {
      if (this.afterCaptchaTimer) clearInterval(this.afterCaptchaTimer)
      this.afterCaptchaCount = 60
      this.afterCaptchaTimer = setInterval(() => {
        if (this.afterCaptchaCount > 0) {
          this.afterCaptchaCount--
        } else {
          clearInterval(this.afterCaptchaTimer)
          this.afterCaptchaTimer = null
        }
      }, 1000)
    },
    resendAfterCaptchaCode() {
      if (this.afterCaptchaSending || this.afterCaptchaCount > 0) return
      this.afterCaptchaSending = true
      this.sendCaptcha({
        randstr: 'skip_captcha',
        ticket: 'skip_captcha',
        phone: this.formData.phone,
        page_url: window.location.href.split('?')[0] || ''
      })
      this.afterCaptchaCount = 60
      this.startAfterCaptchaTimer()
      setTimeout(() => {
        this.afterCaptchaSending = false
      }, 1000)
    },
    changeSmsButton() {
      let count = 60
      this.smsButtonDisable = true

      const timer = setInterval(() => {
        count--
        this.smsButtonValue = `${count}s后可重试`
        if (count === 0) {
          clearInterval(timer)
          this.smsButtonValue = '发送验证码'
          this.smsButtonDisable = false
        }
      }, 1000)
    },
    checkCaptcha() {
      // 检查手机号是否符合规则
      if (!this.patterns.phone.test(this.formData.phone)) {
        Toast('请填写完整手机号')
        return
      }

      if (this.smsButtonDisable) {
        return
      }

      this.reportEvent('click_sms', '')

      // 触发验证码弹窗
      const captchaBtn = document.getElementById('CaptchaId')
      captchaBtn.click()

      // 定时获取验证码结果
      const timer = setInterval(() => {
        const captchaResult = localStorage.getItem('captchaResult')
        if (captchaResult) {
          localStorage.removeItem('captchaResult')
          clearInterval(timer)
          this.captchaCallback(JSON.parse(captchaResult))
        }
      }, 500)

      // 1分钟后退出定时器
      setTimeout(() => {
        clearInterval(timer)
      }, 60000)
    },
    captchaCallback(res) {
      // 取消验证
      if (res.ret !== 0) {
        this.reportEvent('slide_fail', '')
        return
      }
      this.reportEvent('slide_succ', '')

      const randStr = res.randstr
      const ticket = res.ticket

      // 向后端发送验证请求，如果通过，会自动发送短信
      const data = {
        phone: this.formData.phone,
        randstr: randStr,
        ticket: ticket,
        page_url: window.location.href.split('?')[0] || ''
      }
      this.sendCaptcha(data)
    },
    sendCaptcha(data) {
      request.post('/car/sms', data).then((res) => {
        if (res.status && res.status === 'success') {
          // 修改短信按钮状态
          this.changeSmsButton()
        } else {
          Toast(res.msg || '验证失败')
        }
      }).catch((err) => {
        console.log('验证请求错误', err)
        Toast(err.response.data.msg || '验证失败')
      })
    },
    onFailed(error) {
      error.errors.forEach((item) => {
        this.$set(this.formData, item.name, '')
      })
    },
    async onBlur(field_key, field_value_check) {
      if (field_key === 'user_name' && this.formData.user_name && field_value_check.includes('word_filter')) {
        // 检查用户名是否符合规则
        const isRisk = await this.checkRisk(this.formData.user_name)
        if (isRisk) {
          this.$set(this.formData, 'user_name', '')
          Toast('请填写有效的姓名')
        }
      }
    },
    async checkRisk(word) {
      let isRisk = false
      await request.get('/car/filter/word', { word: word }).then((res) => {
        isRisk = res.data.risk === 1
      }).catch((err) => {
        console.log('检查风险词语错误', err)
      })
      return isRisk
    },
    openPPIS() {
      this.ppisShow = true
    },
    savePhone(phone) {
      localStorage.setItem('phone', phone)
      localStorage.setItem('phone_expire', Date.now() + 24 * 60 * 60 * 1000)
    },
    checkPhoneRepeat(phone) {
      const cachePhone = localStorage.getItem('phone')
      const expire = localStorage.getItem('phone_expire')
      if (cachePhone && cachePhone === phone && expire && Date.now() < parseInt(expire)) {
        return true
      }
      return false
    },
    startReportTimer() {
      // 在页面停留 2、5、10、20、40、60 秒上报一次
      const stayTime = [2, 5, 10, 20, 40, 60]
      stayTime.forEach((time) => {
        setTimeout(() => {
          this.reportEvent('stay_time', time)
        }, time * 1000)
      })
    },
    reportEvent(event, value) {
      if (this.queryObj.is_demo) {
        return
      }

      // 提交数据
      const data = {
        ...this.queryObj,
        event: event,
        stay_time: value
      }
      request.post('/car/monitor', data).then((res) => {
        console.log('上报事件', res)
      }).catch((err) => {
        console.log('上报事件错误', err)
      })
    }
  }
}
</script>

<style scoped>
.van-radio {
  margin-bottom: 10px;
}

.img {
  width: 100%;
  height: 100%;
}

.icp {
  text-align: center;
  margin: 16px 0px;
  color: #999;
  font-size: 11px;
}

.radio-group {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.radio-item {
  flex: 0 0 50%; /* 每个选项占据 50% 的宽度 */
}

.dialog-container {
  height: 80vh;
  display: flex;
  flex-direction: column;
}

.dialog-header {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
}

.close-button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.dialog-content {
  height: calc(100% - 100px);
  overflow-y: auto;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  padding: 10px;
}

/* 后置验证码弹窗 */
.after-captcha-mask {
  position: fixed;
  z-index: 99;
  left: 0; top: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.after-captcha-dialog {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  padding: 32px 24px 24px 24px;
  min-width: 300px;
  text-align: center;
}
.after-captcha-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 18px;
}
.after-captcha-inputs {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 18px;
}
.after-captcha-input {
  width: 80%;
  height: 44px;
  font-size: 22px;
  text-align: center;
  border: 1px solid #eee;
  border-radius: 8px;
  outline: none;
  transition: border 0.2s;
}
.after-captcha-input:focus {
  border: 1.5px solid #1989fa;
}
.after-captcha-tips {
  font-size: 13px;
  color: #888;
  margin-top: 8px;
}
.after-captcha-tips a {
  color: #1989fa;
  text-decoration: underline;
  cursor: pointer;
}
.after-captcha-tips a.disabled {
  color: #ccc;
  pointer-events: none;
}
</style>
